import React from 'react';

import WebsiteAdminFetchingSettingNumericFieldRow, {
	WebsiteAdminFetchingSettingNumericFieldRowUnit,
} from '~/components/app/WebsiteAdminFetchingSettingNumericFieldRow';



type Props = {
	name: string,
};

const WebsiteAdminFetchingSettingDomStabilizationPeriodFieldRow: React.FC<Props> = (props) => {
	const {
		name,
	} = props;

	return (
		<WebsiteAdminFetchingSettingNumericFieldRow
			autoValue={3000}
			label="DOM stabilization period"
			name={name}
			unit={WebsiteAdminFetchingSettingNumericFieldRowUnit.Millisecond}
		/>
	);
};



export default WebsiteAdminFetchingSettingDomStabilizationPeriodFieldRow;
